import FilterText from 'components/FilterText';
import { enumStatus } from 'enum/enumStatus';
import { IQuoteListResponse } from 'interfaces/IQuote';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useQuoteService } from 'services/QuoteService';
import { UserAltSlash, Users } from 'styled-icons/fa-solid';
import { Edit, VerifiedUser, Save } from 'styled-icons/material';
import * as S from './style';

const TableQuote: React.FC = () => {
  const [Quotes, setQuote] = useState<IQuoteListResponse[] | null>(null);
  const { QuoteService } = useQuoteService();
  const navigate = useNavigate();

  const getData = useCallback(async () => {
    try {
      const result = await QuoteService.GetQuotesByUser();
      setQuote(result);
    } catch (error) {
      console.log(`error in TableUsers - function getData, error:${error}`);
    }
  }, [QuoteService]);

  const dateFormat = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <S.Container>
      <FilterText
        placeholderInput="Nome do projeto"
        nameFieldToFilter="Name"
        dataToFilter={Quotes}
        setDataToFilter={setQuote}
      />
      {Quotes && Quotes.length > 0 && (
        <Row>
          <Col>
            <div className="table-thead-fixed">
              <Table className="table-striped text-center" responsive>
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Cnpj</th>
                    <th>Projeto</th>
                    <th>Vendedor</th>
                    <th>Canal De Venda</th>
                    <th>Dt. Criação</th>
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {Quotes.map((quote: IQuoteListResponse) => (
                    <tr key={quote.QuoteId}>
                      <td>{quote.ClientName}</td>
                      <td>{quote.ClientDocument}</td>
                      <td>{quote.ProjectName}</td>
                      <td>{quote.VendorAdminUserName}</td>
                      <td>{quote.SalesChannelName}</td>
                      <td>{dateFormat.format(new Date(quote.CreatedDate))}</td>
                      <td>
                        <Button
                          type="button"
                          variant="outline-primary"
                          onClick={() =>
                            navigate('addEditQuote', {
                              state: quote.QuoteId
                            })
                          }
                          title="Editar"
                        >
                          <Edit size={20} />
                        </Button>
                        &nbsp;
                        <Button
                          type="button"
                          variant="outline-primary"
                          onClick={async () => {
                            try {
                              const response = await QuoteService.pdfexport(
                                quote.QuoteId
                              );
                              if (response) {
                                // Converter base64 em ArrayBuffer
                                const byteCharacters = atob(response.File);
                                const byteNumbers = new Array(
                                  byteCharacters.length
                                );
                                for (
                                  let i = 0;
                                  i < byteCharacters.length;
                                  i += 1
                                ) {
                                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                                }
                                const byteArray = new Uint8Array(byteNumbers);
                                const blob = new Blob([byteArray], {
                                  type: 'application/pdf'
                                });
                                const url = window.URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute(
                                  'download',
                                  response.FileName
                                ); // Nome do arquivo para download
                                document.body.appendChild(link);
                                link.click();
                                link.remove();
                              }
                            } catch (error) {
                              console.error('Erro ao exportar PDF:', error);
                            }
                          }}
                          title="Exportar PDF"
                        >
                          <Save size={20} />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      )}
    </S.Container>
  );
};

export default TableQuote;
